import React, { useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import CalenderWrapper from "./Calender.style";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  convertPlanEventsToCalender,
  isNotAvailablePlanEventHours,
} from "../../../components/util/helpers";
import { message } from "antd";
import { extendMoment } from "moment-range";
import Moment from "moment";
const moment = extendMoment(Moment);
const localizer = momentLocalizer(moment);
var tinycolor = require("tinycolor2");

const DragAndDropCalendar = withDragAndDrop(Calendar);
const CalenderComponent = (props) => {
  const {
    activePlan,
    customEvent,
    changeEvent,
    editEvent,
    createEvent,
    ordersBgPalette,
    ordersBorderPalette,
    filteredOrders,
    activePatient,
    intl,
  } = props;
  const displayDragItemInCell = true;
  const localeLang = "he";
  const [draggedEvent, setDraggedEvent] = useState(null);

  const eventStyleGetter = (event, start, end, isSelected) => {
    const startsInCurrentMonth =
      event.order &&
      event.order.effective_from &&
      moment(event.order.effective_from) >= moment().startOf("month");
    const endsInCurrentMonth =
      event.order &&
      event.order.effective_to &&
      moment(event.order.effective_to) <= moment().endOf("month");
    const categoryName =
      event["order"] && event["order"]["client"]
        ? event["order"]["client"]["category"].name
        : "";
    let bgColor = categoryName
      ? ordersBgPalette[categoryName] || "#FBEEF1"
      : "black";
    let borderColor = categoryName
      ? ordersBorderPalette[categoryName] || "#D7C2C8"
      : "black";
    if (startsInCurrentMonth && endsInCurrentMonth) {
      bgColor = tinycolor(bgColor).darken(15).desaturate(10).toHexString(); // "#f53d3d"
      borderColor = tinycolor(borderColor)
        .darken(15)
        .desaturate(10)
        .toHexString(); // "#f53d3d"
    } else if (endsInCurrentMonth) {
      bgColor = tinycolor(bgColor).darken(30).desaturate(10).toHexString(); // "#f53d3d"
      borderColor = tinycolor(borderColor)
        .darken(30)
        .desaturate(10)
        .toHexString(); // "#f53d3d"
    }
    var style = {
      backgroundColor: bgColor,
      opacity: categoryName ? 1 : 0.4,
      borderColor: borderColor,
      borderStyle: "solid",
      borderWidth: "1px",
    };
    return {
      style: style,
    };
  };

  const handleDragStart = (event) => {
    setDraggedEvent(event);
  };

  const dragFromOutsideItem = () => {
    return draggedEvent;
  };

  const shouldChangeEvent = (event, start, end) => {
    // Check if duration is less than 15 minutes
    const durationMinutes = moment(end).diff(moment(start), "minutes");
    if (durationMinutes < 15) {
      return;
    }
    const isNotAvailable = event.nonAvailable
      ? false
      : isNotAvailablePlanEventHours(
          event.employee,
          activePatient,
          start,
          end,
          message,
          intl
        );
    if (!isNotAvailable && !event.is_day_center) {
      changeEvent(event, start, end);
    }
  };

  const moveEvent = ({ event, start, end }) => {
    if (moment(end) > moment(start).endOf("day")) {
      end = moment(end)
        .set({
          day: moment(start).get("day"),
          hour: "23",
          minute: "59",
        })
        .toDate();
    }
    shouldChangeEvent(event, start, end);
  };

  const resizeEvent = ({ event, start, end }) => {
    shouldChangeEvent(event, start, end);
  };

  const newEvent = (event) => {
    const isNotAvailable = event.nonAvailable
      ? false
      : isNotAvailablePlanEventHours(
          event.employee,
          activePatient,
          event.start,
          event.end,
          message,
          intl
        );
    if (!isNotAvailable) {
      createEvent(event);
    }
  };
  const onDoubleClickEvent = (event) => {
    if (!event.nonAvailable && !event.is_day_center) {
      editEvent(event);
    }
  };

  let formats = {
    dayFormat: "dddd",
  };
  var startOfWeek = moment().startOf("week").toDate();
  var scrollTime = moment(startOfWeek).add(6, "hours").toDate(); // see the cloning?
  let tableEvents = [];
  if (
    activePlan &&
    activePlan["recurrent_events"] &&
    activePlan["recurrent_events"].length > 0
  ) {
    activePlan["recurrent_events"].forEach((item, i) => {
      var isFiltered = filteredOrders.includes(item.order_id);
      if (!isFiltered) {
        tableEvents.push(item);
      }
    });
  }
  const convertedEvents = convertPlanEventsToCalender(tableEvents);

  if (
    convertedEvents &&
    activePatient.non_available_hours &&
    activePatient.non_available_hours.length > 0
  ) {
    activePatient.non_available_hours.forEach((item, i) => {
      var startOfWeek = moment().startOf("week");
      const day = startOfWeek.add(item.day_of_week, "days");
      const startDate = day.set("minute", item.start_time_minutes);
      const nonAvailableStart = startDate.toDate();
      const nonAvailableEnd = startDate
        .add(item.duration_minutes, "minutes")
        .toDate();
      convertedEvents.push({
        start: nonAvailableStart,
        end: nonAvailableEnd,
        nonAvailable: true,
        id: 20000 + i,
      });
    });
  }
  return (
    <CalenderWrapper>
      <DragAndDropCalendar
        popup
        formats={formats}
        rtl={localeLang === "he"}
        toolbar={false}
        selectable
        step={15}
        localizer={localizer}
        events={convertedEvents}
        defaultView={Views.WEEK}
        defaultDate={startOfWeek}
        scrollToTime={scrollTime}
        onEventDrop={moveEvent}
        resizable
        onEventResize={resizeEvent}
        onSelectSlot={newEvent}
        onDoubleClickEvent={onDoubleClickEvent}
        dragFromOutsideItem={displayDragItemInCell ? dragFromOutsideItem : null}
        handleDragStart={handleDragStart}
        style={{ height: "100%" }}
        tooltipAccessor={null}
        eventPropGetter={eventStyleGetter}
        components={{
          event: customEvent,
        }}
        showMultiDayTimes
      />
    </CalenderWrapper>
  );
};

export default CalenderComponent;
